<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <v-card tile>
      <v-layout row mt-2 ml-1 mb-3>
        <v-flex sm12>
          <WidgetProjet :projet="detailProjet"></WidgetProjet>
        </v-flex>
      </v-layout>

      <!-- TAB Projet -->
      <v-layout row>
        <v-flex sm12 ml-1 mr-1 mt-1>
          <v-card>
            <el-tabs
              v-model="onglet"
              type="border-card"
              @tab-click="handleTabClick(onglet)"
            >
 
            <el-tab-pane label="Bon de commande interne à valider">
                <!-- LISTE BCI-->
                <listeBciResponsable
                  :typeReche="'ressource'"
                  :listeBesoins="besoins"
                  :listeChantiers="chantiers"
                  :idProjet="this.detailProjet.id"
                  :idresponsable="detailProjet.idChef"
                  @reloadBesoins="loadBesoinAvalider(), loadChantier()"
                ></listeBciResponsable>
                <!-- LISTE CHANTIERS-->
              </el-tab-pane>

<!-- 
              <el-tab-pane label="Demandes de ressources à valider">
                <besoinResponsable
                  :typeReche="'ressource'"
                  :listeBesoins="besoins"
                  :listeChantiers="chantiers"
                  :idProjet="this.detailProjet.id"
                  :idresponsable="detailProjet.idChef"
                  @reloadBesoins="loadBesoinAvalider(), loadChantier()"
                ></besoinResponsable>
              </el-tab-pane> -->

              <el-tab-pane label="Demandes de carburants à valider">
                <!-- LISTE DEMANDE DE CARBURANT-->
                <besoinCarburantResponsable
                  :typeReche="'carburant'"
                  :listeBesoins="besoinsCarbur"
                  :listeChantiers="chantiers"
                  :idProjet="this.detailProjet.id"
                  :idresponsable="detailProjet.idChef"
                  @reloadBesoins="loadBesoinCarburAvalider(), loadChantier()"
                ></besoinCarburantResponsable>
                <!-- LISTE CHANTIERS-->
              </el-tab-pane>
              <el-tab-pane label="Rapport Journaliers">
                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                <ListeRapportTrx
                  :type="2"
                  :commis="false"
                  :typeInterface= true
                  :rapportPerso = "rapportPerso"
                  :show="loadFenetre"
                  :listeRapportTrx="listeRapports"
                  @reloadListeRapport="loadRapportProjet()"
                >
                </ListeRapportTrx>
                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
              </el-tab-pane>
              <el-tab-pane label="Reserve Travaux">
                <!-- RESULATS RESERVE TRAVAUX -->
                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                <ListeReserve
                  :type="2"
                  :listeReserveTrx="listeReserves"
                  @reloadListeReserve="loadReserves()"
                >
                </ListeReserve>
                <!-- LISTE DES RAPPORT TRAVAUX D'UN PROJET -->
                <br />
              </el-tab-pane>

              <el-tab-pane label="Worklog">
                <!-- LISTE DES Worklog D'UN PROJET -->
                <ListeWorklogPorjet
                  :type="2"
                  :listeWorktrx="listeWorktrx"
                  :listeTacheWorktrx="listtache"
                  :idProjet="detailProjet.id"
                  :totalHeuretrx="totalHeuretrx"
                  :totalmintrx="totalmintrx"
                  :totalactivitetrx="totalActivite"
                  @reloadWorklogs="loadWorklogs(detailProjet.id)"
                ></ListeWorklogPorjet>
                <br />
              </el-tab-pane>
            </el-tabs>
          </v-card>
        </v-flex>
      </v-layout>
      <!--FIN  TAB Projet -->

    </v-card>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import besoinResponsable from "@/components/besoin/besoinResponsable";
import listeBciResponsable from "@/components/besoin/listeBciResponsable";
import besoinCarburantResponsable from "@/components/besoin/besoinCarburantResponsable";
import ListeRapportTrx from "@/components/rapport/ListeRapportTrx";
import ListeReserve from "@/components/rapport/ListeReserve";
import ListeWorklogPorjet from "@/components/worklogs/ListeWorklogPorjet";
import WidgetProjet from "@/components/boardProjet/widgetProjet";
export default {
  components: {
    Loading,
    besoinCarburantResponsable,
    listeBciResponsable,
    besoinResponsable,
    ListeWorklogPorjet,
    ListeRapportTrx,
    ListeReserve,
    WidgetProjet
  },
  name: "DashboardOngletPrj",
  props: {
    show: {
      type: Boolean
    },
    detailProjet: {
      type: Object
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogDashboardProjet: false,
      loading: false,
      onglet: "0",

      //ONGLET CHANTIERS
      chantiers: [],

      //ONGLET besoins
      besoins: [],

      // liste des carburation
      besoinsCarbur: [],

      //ONGLET RAPPORS
      listeRapports: [],
      loadFenetre: false,
      rapportPerso: false,
      IddetailTravaux: "",

      //ONGLET RESERVE
      listeReserves: [],

      //ONGLET WORKLOG
      listeWorktrx: [],
      listtache: [],
      totalHeuretrx: [],
      totalmintrx: [],
      totalActivite: []
    };
  },
  methods: {
    //ONGLET CHANTIER
    loadChantier() {
      this.loading = true;
      let url =
        this.domaine + "chantier/liste/" + this.detailProjet.id + "/projet";
      this.$http.get(url).then(
        response => {
          this.chantiers = response.body.chantier;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des chantiers");
        }
      );
    },
    loadBesoinAvalider() {
      this.loading = true;
      let url = this.domaine + "besoin/projet/" + this.detailProjet.id;
      let data = {
        type: "autre"
      };
      this.$http.get(url, { params: data }).then(response => {
        console.log('dhdd',response.body)
        this.besoins = response.body.besoins;

        console.log('dhddddd', this.besoins)

        this.loading = false;
      });
    },
    loadBesoinCarburAvalider() {
      this.loading = true;
      let url = this.domaine + "besoin/projet/" + this.detailProjet.id + "";
      let data = {
        type: "carburant"
      };
      this.$http.get(url, { params: data }).then(response => {
        this.besoinsCarbur = response.body.besoins;
        this.loading = false;
      });
    },

    handleTabClick(tab) {
      switch (tab) {
        case "0" || 0:
          this.loadBesoinAvalider();
          this.loadChantier();
          break;
        // case "1" || 1:
        //   this.loadBesoinAvalider();
        //   this.loadChantier();
        //   break;
        case "1" || 1:
          this.loadBesoinCarburAvalider();
          break;
        case "2" || 2:
          this.loadRapportProjet();
          break;
        case "3" || 3:
          this.loadReserves();
          break;

        case "4" || 4:
          this.loadWorklogs(this.detailProjet.id);
          break;
        default:
          break;
      }
    },
    //onglet rapports
    loadRapportProjet() {
      this.loading = true;
      let url = this.domaine + "journal/projet/" + this.detailProjet.id;
      this.$http.get(url).then(
        response => {
          this.listeRapports = response.body.journaux;
          this.loading = false;
          this.loadFenetre = true;
          //on affecte lid du chantier pour pouvoir retrouver tous les travaux
          // this.IddetailTravaux = this.detailProjet.id;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des Journaux");
        }
      );
    },
    //ONGLET WORKLOG
    loadWorklogs(idProjet) {
      this.loading = true;
      let url = this.domaine + "worklogs/projet/" + this.detailProjet.id;
      this.$http.get(url).then(
        response => {
          this.listeWorktrx = response.body.listeWorklog;
          this.totalHeuretrx = response.body.totalheure;
          this.totalmintrx = response.body.totalMinutes;
          this.totalActivite = response.body.totalActivite;
          this.listtache = response.body.listTacheeWorklog;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des worklogs");
        }
      );
    },

    //ONGLET RESERVE
    loadReserves() {
      this.loading = true;
      let url = this.domaine + "reserve/projet/" + this.detailProjet.id;
      this.$http.get(url).then(
        response => {
          this.listeReserves = response.body.reserves;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des reserves");
        }
      );
    },

    closeDialog() {
      this.besoins.splice(0);
      this.chantiers.splice(0);
      this.$emit("close");
    }
  },

  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDashboardProjet = newValue;
      if (newValue == true) {
        this.onglet = "0";
        this.loadChantier();
        this.loadReserves();
        this.loadBesoinAvalider();
        this.loadRapportProjet();
      }
    }
  }
};
</script>

<style>
.list {
  height: auto !important;
}
.list__tile__sub-title {
  height: 300px;
}
.list__tile__title {
  height: 178px;
}
.list__tile__content,
.list__tile__action {
  height: 73%;
}
</style>



// WEBPACK FOOTER //
// src/components/boardProjet/dashboardOngletPrj.vue